import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { VenderJson } from "../../../DynamicFormsJson/MastersJSON/vender";
import { MyComponentWithIconProps } from "../../../components/Comman/IconButton";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { imageUrl } from "../../../config/Url";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class VenderView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  onClickViewPreview = (e, row) => {
    window.open(imageUrl + row, "_blank");
  };

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: VenderJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Region",
                  value:
                    data.data.region !== null && data.data.region.name !== null
                      ? data.data.region.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Zone",
                  value:
                    data.data !== null && data.data.zoneNames !== null
                      ? data.data.zoneNames
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Area",
                  value:
                    data.data !== null && data.data.areaNames !== null
                      ? data.data.areaNames
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Name",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Address",
                  value:
                    data.data !== null && data.data.address !== null
                      ? data.data.address
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "PAN Number",
                  value:
                    data.data !== null && data.data.panNo !== null
                      ? data.data.panNo
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "GST Applicable",
                  value:
                    data.data !== null && data.data.gstApplicable !== null
                      ? data.data.gstApplicable == "0"
                        ? "No"
                        : "Yes"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "GST Applicable",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup
                //           value={data.data.gstApplicable}
                //           row
                //           name="gstApplicable"
                //         >
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="No"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Yes"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Contact Number",
                  value:
                    data.data !== null && data.data.contactNumber !== null
                      ? data.data.contactNumber
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Email Id",
                  value:
                    data.data !== null && data.data.emailId !== null
                      ? data.data.emailId
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Firm Image",
                  value:
                    data.data.firmImage !== null ? (
                      <MyComponentWithIconProps
                        statusImage={VisibilityIcon}
                        sx={{ marginRight: "45px", align: "center" }}
                        color="primary"
                        fontSize="medium"
                        title="View"
                        onClick={(e) =>
                          this.onClickViewPreview(e, data.data.firmImage)
                        }
                      />
                    ) : (
                      "-"
                    ),
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Vendor View"}
            fieldMeta={[]}
            apiBaseURL={VenderJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(VenderView);
